<template>
  <!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
  <BFormInput v-bind="$attrs"
              ref="inputField"
              :value="value"
              :state="state"
              :disabled="disabled"
              :type="type"
              v-on="$listeners">
  </BFormInput>
  <!-- eslint-enable -->
</template>
<script>
  import { BFormInput } from 'bootstrap-vue';
  import validation from '../mixins/validation';

  export default {
    name: 'TextInput',
    components: {
      BFormInput,
    },
    mixins: [
      validation,
    ],
    props: {
      value: {
        type: String,
      },
      state: {
        type: Boolean,
        default: null,
      },
      type: {
        type: String,
        default: 'text',
      },
      disabled: Boolean,
    },
    expose: ['focus', 'blur'],
    methods: {
      async focus() {
        await this.$nextTick();
        this.$refs.inputField.focus();
      },
      blur() {
        this.$refs.inputField.blur();
      },
    },
  };
</script>
